import { Button, FormGroup, MenuItem, NumericInput } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import {
  TileRotatePattern,
  type AnimationOptionFlip,
} from "@package/ui-gql/index-data-access";
import { TILE_ROTATE_PATTERN_TO_DISPLAY } from "../../../../../constants/contants";

type AnimationOptionFlipComponentProps = {
  disabled: boolean;
  option: AnimationOptionFlip;
  onOptionUpdated: (option: AnimationOptionFlip) => void;
};

export function AnimationOptionFlipComponent({
  disabled,
  option,
  onOptionUpdated,
}: AnimationOptionFlipComponentProps) {
  return (
    <>
      <FormGroup disabled={disabled} label="Flip Direction" fill>
        <Select<TileRotatePattern>
          activeItem={option.direction ?? TileRotatePattern.Horizontal}
          disabled={disabled}
          fill
          filterable={false}
          items={Object.values(TileRotatePattern)}
          itemRenderer={(type, { handleClick, handleFocus, modifiers }) => (
            <MenuItem
              active={modifiers.active}
              disabled={modifiers.disabled}
              key={type}
              onClick={handleClick}
              onFocus={handleFocus}
              roleStructure="listoption"
              text={TILE_ROTATE_PATTERN_TO_DISPLAY[type]}
            />
          )}
          popoverProps={{ minimal: true }}
          onItemSelect={(direction) =>
            onOptionUpdated({
              ...option,
              direction,
            })
          }
        >
          <Button
            alignText="left"
            disabled={disabled}
            minimal
            outlined
            fill
            rightIcon="caret-down"
            text={
              option.direction
                ? TILE_ROTATE_PATTERN_TO_DISPLAY[option.direction]
                : "Select a Direction"
            }
          />
        </Select>
      </FormGroup>
      <FormGroup
        disabled={disabled}
        label="Flip Duration Seconds"
        fill
        helperText="Duration of the fade animation in seconds"
      >
        <NumericInput
          min={0}
          disabled={disabled}
          allowNumericCharactersOnly
          fill
          value={option.duration ?? 0}
          onValueChange={(duration) => {
            onOptionUpdated({
              ...option,
              duration,
            });
          }}
        />
      </FormGroup>
    </>
  );
}
